import Vue from 'vue'
import config from '@/config'
// axios
import axios from 'axios'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: config.BASE_URL
  baseURL: process.env.VUE_APP_BACKEND_BASE_URL
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

Vue.prototype.$http = axiosIns

export default axiosIns
